<template lang="html">
	<div class="createDownload-main">
		<div class="createDownload-container">
			<div class="breadCrumb-container">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>{{$t('message.download')}}</el-breadcrumb-item>
					<el-breadcrumb-item>{{$t('message.createTaskDeleteMenu')}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="body-container verifone-panel btn-table"  v-show="isTableShow">
				<template>
					<div class="table-container">
						<div class="table-main">
							<template>
								<el-table ref="multipleTableCreate" :data="createTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
									<el-table-column type="selection" width="55" />
									<el-table-column label="" width="50">
										<template slot-scope="scope">
											<img class="logo-icon" :src="scope.row.logo" alt="">
										</template>
									</el-table-column>
									<el-table-column label="APP" :show-overflow-tooltip="true">
										<template slot-scope="scope">{{ scope.row.name }}</template>
									</el-table-column>
<!-- 									<el-table-column prop="version" :label="$t('message.version')" :show-overflow-tooltip="true" /> -->
                  <el-table-column prop="company" :label="$t('message.company')" :show-overflow-tooltip="true" />
									<el-table-column prop="utime" :label="$t('message.date')" :show-overflow-tooltip="true" />
									<el-table-column prop="size" :label="$t('message.size')" :show-overflow-tooltip="true" width="120" />
								</el-table>
							</template>
						</div>

						<div class="pagination-main">
							<el-pagination  background layout="prev, pager, next" :total="totalPage*10" @current-change="changePage"></el-pagination>
						</div>

						<div class="createBtn-main">
							<div class="num-container">
								<span v-text="selectedLength"></span><span> {{$t('message.appChoose')}}</span>
							</div>
							<el-button class="verifone-btn createTask" type="success" plain icon="el-icon-download" @click="createTask">{{$t('message.createDeleteTask')}}</el-button>
						</div>
					</div>
				</template>
			</div>

			<div class="body-container verifone-panel" v-show="isSelectorShow">
				<template>
				 	<div class="createSelector-container">
            <div class="createSelector-main">

              <!-- 删除任务名称 -->
							<div class="create-item">
								<div class="create-left">
									<div class="task-title title">
										<span class="required">*</span>
                    <span>{{$t('message.DeleteTaskName')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="taskName-container">
                    <el-input class="taskName" v-model="taskName" :placeholder="$t('message.charTip50')" maxLength="50"></el-input>
                  </div>
								</div>
							</div>

              <!-- 删除时间 -->
							<div class="create-item">
								<div class="create-left">
									<div class="date-title title">
                    <span>{{$t('message.deleteTime')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="date-selector">
                    <el-radio-group v-model="delRadio">
                      <el-radio :label="0">{{$t('message.nextContact')}}</el-radio>
                      <el-radio :label="1">{{$t('message.DeleteTime')}}</el-radio>
                    </el-radio-group>
                    <div class="date-picker-container">
                      <div class="block">
                        <el-date-picker :disabled="updateDownload" v-model="delDate1"  :picker-options="pickerOptions1" type="date" value-format="yyyy-MM-dd" :editable="false" :placeholder="$t('message.date')"></el-date-picker>
                      </div>
                    </div><br>
                    <div class="time-selector">
                      <template>
                        <el-time-select :disabled="updateDownload" :editable="false" v-model="delTime1" :picker-options="{start: '00:00', step: '01:00',end: '24:00'}" :placeholder="$t('message.time')"/>
                      </template>
                    </div>
                  </div>
								</div>
							</div>

              <!-- 删除提醒 -->
							<div class="create-item">
								<div class="create-left">
									<div class="notification-title title">
                    <span>{{$t('message.DeleteWarning')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="install-selector">
                    <el-radio-group v-model="installNotification">
                      <el-radio :label="0">{{$t('message.SilentUninstall')}}</el-radio>
                      <el-radio :label="1">{{$t('message.askOperator')}}</el-radio>
                    </el-radio-group>
                   </div>
								</div>
							</div>

              <!-- 是否强制卸载 -->
              <div class="create-item">
                <div class="create-left">
                  <div class="notification-title title">
                    <span>{{$t('message.forceUninstall')}}</span>
                  </div>
                </div>
                <div class="create-right">
                  <div class="install-selector">
                    <el-radio-group v-model="forceUninstall">
                      <el-radio :label="0">{{$t('message.no')}}</el-radio>
                      <el-radio :label="1">{{$t('message.yes')}}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>

              <!-- 发布范围 -->
							<div class="create-item">
								<div class="create-left">
									<div class="notification-title title">
                    <span>{{$t('message.pushRange')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="install-selector">
                    <el-radio-group v-model="range">
                      <el-radio :label="0">{{$t('message.allTerminal')}}</el-radio>
                      <el-radio :label="1">{{$t('message.grayscale')}}</el-radio>
                    </el-radio-group>
										<el-select multiple collapse-tags filterable :disabled="updateRange" v-model="valueGroups" style="width: 305px;" :placeholder="$t('message.pleaseChoose')">
											<el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id"/>
										</el-select>
                  </div>
								</div>
							</div>
            </div>

            <div class="createSelector-footer">
							<div class="submit-container">
                <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="toCreateList">{{$t('message.cancel')}}</el-button>
                <el-button class="verifone-btn" type="primary" icon="el-icon-document" @click="handleSubmit">{{$t('message.submit')}}</el-button>
              </div>
            </div>

           <!--  点击按钮提醒是否下发该任务-->
            <el-dialog title="" class="quit-dialog warn-dialog" :visible.sync="createConfirm" width="30%" :close-on-click-modal="false" :close-on-press-escape="false">
							<div class="warn-container flex-row">
								<img class="warn-icon" alt="" src="static/img/alertWarn.png">
								<span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
							</div>
							<div class="dialog-body">
								{{$t('message.createTaskTipsStart')}}&#160; </span><span>{{selectedAppResult}}&#160; </span><span>{{$t('message.createDelTaskTipsEnd')}}</span>
							</div>
                <span slot="footer" class="dialog-footer">
                  <el-button class="verifone-btn" type="primary" plain @click="createConfirm = false">{{$t('message.no')}}</el-button>
                  <el-button class="verifone-btn" type="primary" @click="submitCreateDel">{{$t('message.yes')}}</el-button>
                </span>
            </el-dialog>
          </div>
				</template>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	inject: ['reload'],
	data() {
		return {
		  count:0,
			isTableShow: true,
			isSelectorShow: false,
      delRadio: 0,
      installNotification: 0,
			range: 0,
			token: '',
			pageFlag: false,
      taskName: '',
      delDate1: '',
      delTime1: '',
      createConfirm: false,
			currentPage: 1,
			totalPage: 1,
			selectedApp: [],
			selectedLength: 0,
			createList: [],
			createTable: [],
			multipleSelection: [],
      selectedAppResult:'',//弹框内容显示
			inputCheck: this.$t('message.inputCheck'),
			dateCheck: this.$t('message.dateCheck'),
			installDateCheck: this.$t('message.installDateCheck'),
			createSuccess: this.$t('message.createSuccess'),
			chooseApp: this.$t('message.chooseApp'),
      createBack: this.$t('message.createBack'),
      yes:this.$t('message.yes'),
      no:this.$t('message.no'),
			pickerOptions1: {
				disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
			},
			pickerOptions2: {
				disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
			},
			pickerOptions3: {
				disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
			},
			groups: [],
			valueGroups: [],
      forceUninstall:0
		}
	},
	mounted() {
    this.queryAppListInit(1);
  },
	computed: {
		updateDownload: function() {
			return !this.delRadio;
		},
		updateRange: function() {
			return !this.range;
		},
    changeData(){
      const {taskName,delDate1,delTime1,range,installNotification,delRadio}=this;
      return{
        taskName,delDate1,delTime1,range,installNotification,delRadio
      }
    }
	},
  watch:{
    changeData: {
      handler(oldVal, newVal) {
        if (oldVal==newVal) {
          this.count == 0;
        }else  {
          this.count++;
        }
      },
      deep: true
    }
  },
	methods: {
		setToken() {
			this.token = new Date().getTime();
		},
    /* 参数信息校验 并询问是否提交*/
		handleSubmit() {
			// 任务名 完整性校验
			if(!this.taskName || this.taskName == '') {
				this.$message({
					type: "error",
					message: this.inputCheck,
					duration:'3000',
				});
				return;
			}

      // 删除时间校验
			if(this.delRadio == 1) {
				if(this.delDate1 == '' || this.delTime1 == '') {
					this.$message({
						type: "error",
						message: this.dateCheck,
						duration:'3000',
					});
					return;
				}
			}

     
			this.createConfirm = true;
		},

     /*返回*/
		toCreateList() {
      if(this.count>0) {
        this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
          confirmButtonText: this.$i18n.t('message.yes'),
          cancelButtonText: this.$i18n.t('message.no'),
          type: 'warning'
        }).then(() => {
          this.isSelectorShow = false;
          this.isTableShow = true;
          this.reload();
        })
      }else{
        this.isSelectorShow = false;
        this.isTableShow = true;
        this.reload();
      }
    },

    /* 创建删除任务 */
		createTask() {
			if(this.selectedLength === 0) {
				this.$message({
					type: "error",
					message: this.chooseApp,
					duration:'3000',
				});
				return;
			}
			this.isTableShow = false;
			this.isSelectorShow = true;
			this.delRadio = 0;
      this.installNotification = 0;
      this.taskName = '';
      this.delTime1 = '';
      this.installDate = '';
      this.installTime1 = '';
      this.installTime2 = '';
			this.queryGroup();
			this.setToken();
      
      for(let i=0; i<this.selectedApp.length; i++) {
      	for(let j=0; j<this.selectedApp[i].length; j++) {
      		if(this.selectedApp[i][j]) {
            this.selectedAppResult= this.selectedAppResult +this.selectedApp[i][j].name+"-"+this.selectedApp[i][j].version+"，"
      		}
      	}
      }
         this.selectedAppResult  = this.selectedAppResult.substring(0,this.selectedAppResult.length-1);
      
      
		},

		queryGroup() {
			this.$axios({
        method: 'get',
        url: "/marketplace/common/query/group",
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
      }).then(response => {
        if (response.data.resultCode != 0) {
          this.$message({
            type: "error",
            message: response.data.desc,
            duration:'3000',
          });
          return;
        }else {
          this.groups = response.data.groups;
        }
      }).catch((err) => {
        console.log(err);
      });
		},

		handleSelectionChange(val) {
			let pageIndex = this.currentPage - 1,
				checkedLength = 0,
				that = this;

			console.log(this.pageFlag);
			if(!this.pageFlag) {
				this.multipleSelection = val;
				this.selectedApp[pageIndex] = val;
			}else {
				that.pageFlag = false;
			}

			for(let i=0; i<this.selectedApp.length; i++) {
				checkedLength += this.selectedApp[i].length;
			}

			this.selectedLength = checkedLength;
		},
		changePage(num) {
			//判断当前页面已选app列表是否为空，如为空则不需要刷新选择，pageFlag为false
			this.pageFlag = this.selectedApp[num - 1].length === 0 ? false : true ;

			this.currentPage = num;

			this.queryAppList(num);
		},
		toggleSelection(rows) {
			let that = this;

			if (rows) {
				rows.forEach(row => {
					this.createTable.forEach((item, index) => {
						if(item.id == row.id) {
							this.$refs.multipleTableCreate.toggleRowSelection(this.createTable[index], true);
						}
					});
				});
			} else {
				this.$refs.multipleTableCreate.clearSelection();
			}

		},
		queryAppList(page) {
			let that = this;
			let obj = {
        pageNum: page
      };

			this.$axios({
        method: 'post',
        url: '/marketplace/app/page',
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
        data: obj
      }).then(response => {
        if (response.data.resultCode != 0) {
          this.$message({
            type: "error",
            message: response.data.desc,
            duration:'3000',
          });
          return;
        }else {
          this.createTable = response.data.appList;
					this.totalPage = response.data.totalPage;

					//selected
					this.multipleSelection = this.selectedApp[page - 1];

					setTimeout(function() {
						that.toggleSelection(that.multipleSelection);
					}, 200);

        }
      }).catch((err) => {
        console.log(err);
      });
		},

    /* 获取APP列表 */
		queryAppListInit(page) {
			let obj = {
        pageNum: page
      };
			this.$axios({
        method: 'post',
        url: '/marketplace/app/page',
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
				data: obj
      }).then(response => {
        if (response.data.resultCode != 0) {
          this.$message({
            type: "error",
            message: response.data.desc,
            duration:'3000',
          });
          return;
        }else {
          this.createTable = response.data.appList;
					this.totalPage = response.data.totalPage;
					for(let i=0; i<response.data.totalPage; i++) {
						this.selectedApp[i] = [];
					}
        }
      }).catch((err) => {
        console.log(err);
      });
		},

    // 提交删除任务
		submitCreateDel() {
			let appIdList = [],
				that = this,
				obj = {
          appList: appIdList,
          taskName: this.taskName,
          delType: this.delRadio,
          delDate: this.delDate1,
          delTime: this.delTime1,
          remindType: this.installNotification,
					releaseRangeType: this.range,
					releaseRangeList: this.valueGroups,
					token: this.token,
          forceUninstall: this.forceUninstall
        };

			for(let i=0; i<this.selectedApp.length; i++) {
				for(let j=0; j<this.selectedApp[i].length; j++) {
					if(this.selectedApp[i][j]) {
						appIdList.push(this.selectedApp[i][j].id);
					}
				}
			}

			this.$axios({
        method: 'post',
        url: '/marketplace/task/app/del',
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
        data: obj
      }).then(response => {
        if (response.data.resultCode != 0) {
          that.$message({
            type: "error",
            message: response.data.desc,
            duration:'3000',
          });
          return;
        }else {
          that.$message({
            type: "success",
            message: this.createSuccess,
            duration:'3000',
          });
					that.createConfirm = false;
					that.toggleSelection();
					that.isSelectorShow = false;
					that.isTableShow = true;
					this.reload();
        }
      }).catch((err) => {
        console.log(err);
      });
    }
	}

}
</script>

<style scoped="scope">
  .has-gutter {
    border-bottom: 1px solid #00a0e8;
  }
  /* .createSelector-main, .date-picker-container, .createSelector-footer { */
  .date-picker-container, .createSelector-footer, .create-item {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
  }
  .createSelector-container, .download-date, .download-time, .selector-left, .el-radio-group,
  .selector-right, .install-selector {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
  }
  .createSelector-container {
    padding: 30px 20px;
    /* margin-top: 20px; */
    background-color: #fff;
  }
  .selector-left {
    border-right: 1px solid #bbb;
  }
  .createSelector-main {
    width: 100%;
  }
  .el-radio+.el-radio {
    margin-left: 0;
  }
  .title {
    padding: 0 20px;
  }
  .el-radio {
    height: 30px;
  }
  .el-date-editor {
    width: 140px!important;
  }
  .date-split {
    height: 40px;
    line-height: 40px;
    margin: 0 10px;
  }
  .time-split {
    height: 40px;
    line-height: 40px;
    margin: 0 5px;
  }
  .download-time {
    margin-top: 40px;
  }
  .install-time-selector {
    margin-top: 15px;
  }
  .arrows-right {
    width: 25px;
    height: 25px;
    position: relative;
    bottom: -7px;
  }
  /* .load-selector {
      background-color: #58D56D!important;
      color: #fff!important;
      padding: 10px 15px;
      margin: 0 3px 0 20px;
      border: none;
  } */
  .createSelector-footer {
    justify-content: flex-end;
    margin-top: 20px;
  }
  .title span {
    font-size: 16px;
    font-family: 'Arial';
  }
  .table-container {
    margin-top: 20px;
    background-color: #fff;
    position: relative;
  }
  .table-main {
    padding: 20px;
  }
  .pagination-main {
    padding: 10px 0 30px 0!important;
  }
  .createBtn-main {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    position: absolute;
    right: 20px;
    bottom: 30px;
    align-items: center;
    padding-right: 10px;
  }
  .load-selector {
    background-color: #58D56D!important;
    color: #fff!important;
    padding: 10px 15px;
    margin: 0 3px 0 20px;
    border: none;
  }
  .arrows-left {
    width: 25px;
    height: 25px;
    transform: rotate(180deg);
    position: relative;
    bottom: 0px;
    cursor: pointer;
    margin-left: 10px;
  }
  .num-container {
    font-size: 15px;
    color: #666;
  }
  .required {
    color: red;
    font-size: 30px;
    font-weight: 600;
    /* position: absolute;
    top: 10px;
    left: -20px; */
  }
  .taskName-container {
    position: relative;
  }
  .selector-left, .selector-right {
    padding: 40px;
  }
  .taskName {
    width: 305px;
  }
  .arrows-right {
    cursor: pointer;
  }
  .logo-icon {
    width: 36px;
    height: 36px;
  }
  .title-container {
    padding-left: 20px;
  }
  .createTask {
    width: 120px;
    margin-left: 20px;
  }
  .create-item {
    margin-bottom: 20px;
  }
  .create-left {
    width: 18vw;
    display: flex;
    display: -webkit-display;
    justify-content: flex-end;
  }
  .verifone-panel {
    /* margin-top: 62px; */
    margin-top: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/CreateDelete.vue